import React from 'react';
import '../pages/pages.css';
import { useNavigate } from 'react-router-dom';
import '../pages/pages.css';
import { FormattedMessage } from 'react-intl';

const Footer = () => {
    const navigate = useNavigate();

    const handlePrivacyClick = (event) => {
        event.preventDefault();
        navigate('/privacy');
    };
    return (
        <div className="footer">
            <div className="footer-section">
                <div>
                    <p>
                        <FormattedMessage
                            id="footer.info"
                            defaultMessage="The website eminencecodex.com is not affiliated with nor endorsed by Team CARAVAN, Aiming Inc., or Crunchyroll, LLC. All images belong to their respective copyright holders."
                        />
                    </p>
                    <p>© 2025 eminencecodex.com | <a href="/privacy" onClick={handlePrivacyClick}>
                        <FormattedMessage
                            id="footer.privacy"
                            defaultMessage="Privacy"
                        />
                    </a>
                    </p>
                </div>
            </div>

        </div >
    );
};

export default Footer;